(function () {
    'use strict';

    angular
		.module('skillsApp')
        .controller('EmployeeController', EmployeeController);

    function EmployeeController($scope, $filter, $q, $state, $stateParams, $translate, $timeout, logger, uiGridConstants, config, dataService, jsReportService, notifyingService, modalDialogService) {
        var vm = this;
        var selectedUserQuality = null;

        vm.active = 1;
        //vm.isAuthorizedForEmployeesTab = config.settings.user.isExaminer; // todo: maybe turn this on for assessors? -> || config.settings.user.isAssessor;
        vm.isAuthorizedForEmployeesTab = config.settings.user.isExaminer || config.settings.user.isAssessor || config.settings.user.isAdmin || config.settings.user.isManager;

        vm.myGridOptions = {
            enableFiltering: true,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.myGridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false,
                    minWidth: 250
                },
                {
                    displayName: $translate.instant('department'),
                    name: 'departmentName',
                    visible: !config.settings.onlyAssignToFunctions,
                    enableColumnMenu: false,
                    width: 200
                },
                {
                    displayName: $translate.instant('function'),
                    name: 'functionName',
                    enableColumnMenu: false,
                    width: 200,
                },
                {
                    displayName: $translate.instant('progress'),
                    name: 'progress',
                    cellTemplate: '/app/templates/common/userquality-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    width: 150,
                    enableFiltering: false
                },
                {
                    displayName: $translate.instant('expiry_date'),
                    name: 'dateOfExpiry',
                    cellTemplate: '/app/templates/common/date-of-expiry-cell.tpl.html',
                    width: 150,
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/common/grid-buttons-edit.tpl.html',
                    width: 80,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.assignedGridOptions = {
            enableFiltering: true,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.assignedGridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('employee'),
                    name: 'employeeName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 1
                    }
                },
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC
                    }
                },
                {
                    displayName: $translate.instant('activity'),
                    name: 'activityName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC
                    }
                },
                {
                    displayName: $translate.instant('last_result'),
                    name: 'lastResult.createdAt',
                    cellTemplate: '/app/templates/common/last-result-cell.tpl.html',
                    width: 150,
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/common/grid-buttons-edit.tpl.html',
                    width: 80,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.userActivitiesGridOptions = {
            enableFiltering: true,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.userActivitiesGridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC
                    }
                },
                {
                    displayName: $translate.instant('activity'),
                    name: 'activityName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC
                    }
                },
                {
                    displayName: $translate.instant('last_result'),
                    name: 'lastResult.createdAt',
                    cellTemplate: '/app/templates/common/last-result-cell.tpl.html',
                    width: 150,
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/common/grid-buttons-edit.tpl.html',
                    width: 80,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.editEntity = editEntity;
        vm.isCurrentState = isCurrentState;
        vm.loadMyData = loadMyData;
        vm.onSelectUser = onSelectUser;
        vm.searchUsers = searchUsers;
        vm.setActive = setActive;

        notifyingService.subscribe($scope, 'userquality-updated', function (event, args) {
            if (selectedUserQuality && selectedUserQuality.id === args.id) {
                loadMyData();
            }
        });

        $scope.$watch("vm.active", () => {
            switch (vm.active) {
                case 1:
                    loadMyData();
                    break;
                case 2:
                    loadEmployeeActivities();
                    break;
                case 3:
                    loadExaminerData();
                    break;
            }
        });

        $scope.$watch('vm.filterValues', function (n, o) {
            if (o === n) return;
            loadMyData();
        }, true);

        $scope.$watch('vm.selectedUser', function (n, o) {
            if (o === n) return;
            if (n) {
                loadEmployeeActivities();
            }
        }, true);

        _initialize();

        function _downloadReport(type) {
            var reportInfo = {
                name: config.settings.user.displayName,
                onlyAssignToFunctions: config.settings.onlyAssignToFunctions
            };
            return jsReportService.getUserQualitiesReport(type, vm.myGridOptions.data, reportInfo);
        }

        function _initialize() {
            loadExaminerData();
        }
        
        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function editEntity(entity) {
            if (entity.id) { // user
                selectedUserQuality = entity;
                $state.go('app-main.employee.userquality', { id: entity.id });
            } else if (entity.userQualityId) { // examiner
                modalDialogService.openMarkDialog(entity).then(result => {
                    loadEmployeeActivities();
                    loadExaminerData();
                });
            }
        }

        function isCurrentState() {
            return $state.is('app-main.employee');
        }

        function loadEmployeeActivities() {
            vm.userActivitiesGridOptions.data = [];

            if (!vm.selectedUser) return;

            dataService.getEmployeeActivities(vm.selectedUser.idString).then(response => {
                vm.userActivitiesGridOptions.data = response || [];
                vm.userActivitiesGridOptions.gridApi.core.handleWindowResize();
            });
        }

        function loadExaminerData() {
            dataService.getExaminerActivities().then(response => {
                vm.assignedData = response || [];
                vm.assignedGridOptions.data = vm.assignedData;
                vm.assignedGridOptions.gridApi.core.handleWindowResize();

                if (vm.assignedData.length === 0 && vm.active === 3) {
                    vm.active = 1;
                }
            });
        }

        function loadMyData() {
            vm.myGridOptions.data = [];

            if (!vm.filterValues) return;

            var params = {
                assignedTo: vm.filterValues.assignedTo,
                status: vm.filterValues.status,
                connected: vm.filterValues.connected,
                doesNotApply: vm.filterValues.doesNotApply
            };

            return dataService.getMyUserQualities(params).then(userQualities => {
                vm.myGridOptions.data = userQualities;
                vm.myGridOptions.gridApi.core.handleWindowResize();
            });
        }

        function onSelectUser() {
            vm.selectedUser = angular.copy(vm.userSearch);
            delete vm.userSearch;
        }

        function searchUsers(search) {
            vm.isLoading = true;

            return dataService
                .searchExaminerUsers(search)
                .then(response => {
                    vm.isLoading = false;
                    return _.map(response.results, user => { return { name: user.employeeName, type: user.logOnName, idString: user.studentIdString }; });
                });
        }

        function setActive(active) {
            vm.active = active;
        }
    }
})();